import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { AppState, createAppSlice } from '@/slices/appSlice';
import { CourseModeState, createCourseModeSlice } from '@/slices/courseModeSlice';
import { createOTASlice, OTASlice } from '@/slices/otaSlice';
import { createPracticeSlice, PracticeState } from '@/slices/practiceSlice';
import { createStageSlice, StageState } from '@/slices/stageSlice';
import { createTestSlice, TestState } from '@/slices/testSlice';

export interface StoreState
  extends AppState,
    TestState,
    StageState,
    PracticeState,
    OTASlice,
    CourseModeState {}

const enableDevtools = import.meta.env.VITE_ENABLE_DEVTOOLS === 'true';
const useStore = create<StoreState>()(
  enableDevtools
    ? devtools(
        (set, get, store) => ({
          ...createAppSlice(set, get, store),
          ...createTestSlice(set, get, store),
          ...createStageSlice(set, get, store),
          ...createPracticeSlice(set, get, store),
          ...createOTASlice(set, get, store),
          ...createCourseModeSlice(set, get, store),
        }),
        { name: 'SwiftPal', store: 'SwiftPal' },
      )
    : (set, get, store) => ({
        ...createAppSlice(set, get, store),
        ...createTestSlice(set, get, store),
        ...createStageSlice(set, get, store),
        ...createPracticeSlice(set, get, store),
        ...createOTASlice(set, get, store),
        ...createCourseModeSlice(set, get, store),
      }),
);

export default useStore;
